import * as angular from 'angular';

import { InvalidCountDTO } from '../../models/DTO';
import { IRequestService } from '../request.service';

export interface ISynchronizeService {
    countInvalidValues(): angular.IPromise<InvalidCountDTO>;
    synchronizeAll(): angular.IPromise<number>;
}

export class SynchronizeService implements ISynchronizeService {
    static serviceId = 'synchronizeService';
    static serviceUrl = 'synchronize';
    static $inject = ['$q', 'requestService'];
    constructor(private _$q: angular.IQService,
        private _requestService: IRequestService) {
    }

    countInvalidValues(): angular.IPromise<InvalidCountDTO> {
        const url = SynchronizeService.serviceUrl + '/invalid/count';
        this._requestService.cleanCacheAtV1(url);
        return this._requestService.getAtV1(url);
    }

    synchronizeAll(): angular.IPromise<number> {
        this._requestService.cleanCacheAtV1(SynchronizeService.serviceUrl + '/invalid/count');
        return this._requestService.postAtV1(SynchronizeService.serviceUrl);
    }
}

